import { StatusErrorIcon, StatusWarningIcon } from '@/uicomponents';
import styles from './result-glyph.module.css';

export interface ResultGlyphProps {
  tone: 'error' | 'muted';
}

/**
 * Replaces antd's stock `Result` status artwork on the 403 and 404 screens.
 *
 * Those SVGs ship **17 hardcoded fills** apiece, none of them on this palette — a colour
 * leak on two user-visible screens that no token rename could ever reach, and the reason
 * P3 ("antd internals accepted as-is") does not stretch here: P3 covers a 10px radius and
 * a disabled opacity, not a full illustration in another product's colours.
 */
export const ResultGlyph = ({ tone }: ResultGlyphProps) => {
  const className = tone === 'error' ? `${styles.glyph} ${styles.error}` : styles.glyph;
  return tone === 'error' ? (
    <StatusErrorIcon className={className} />
  ) : (
    <StatusWarningIcon className={className} />
  );
};
